import { ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router'
import { AnimatedButton } from '#app/components/ui/animated-button'
import type { BlogPost } from '#app/data/blog'

export function FeaturedPost({ post }: { post: BlogPost }) {
	return (
		<div className="overflow-hidden rounded-2xl border border-[#AEAEAE] bg-white">
			<div className="grid grid-cols-1 md:grid-cols-2">
				<div className="aspect-[4/3] overflow-hidden md:aspect-auto">
					<img
						src={post.featuredImage ?? post.coverImage}
						alt={post.title}
						className="h-full w-full object-cover"
					/>
				</div>

				<div className="flex flex-col justify-center p-8 md:p-12">
					<div className="mb-4 flex items-center gap-3">
						<span className="rounded-full bg-[#32302F] px-3 py-1 text-xs font-medium text-white">
							Featured
						</span>
						<span className="rounded-full bg-[#F8F9FA] px-3 py-1 text-xs font-medium text-[#32302F]">
							{post.category}
						</span>
					</div>

					<h2 className="mb-4 font-['Futura_Hv_BT'] text-[24px] leading-snug text-[#32302F] md:text-[30px]">
						{post.title}
					</h2>

					<p className="mb-6 text-sm leading-relaxed text-[#747474] md:text-base">
						{post.excerpt}
					</p>

					<div className="mb-6 flex items-center gap-3">
						<img
							src={post.author.avatar}
							alt={post.author.name}
							className="h-10 w-10 rounded-full object-cover"
						/>
						<div>
							<p className="text-sm font-medium text-[#32302F]">
								{post.author.name}
							</p>
							<p className="text-xs text-[#747474]">
								{new Date(post.publishedAt).toLocaleDateString('en-CA', {
									year: 'numeric',
									month: 'long',
									day: 'numeric',
								})}{' '}
								· {post.readTime} min read
							</p>
						</div>
					</div>

					<AnimatedButton
						asChild
						className="self-start rounded-[52px] bg-[#32302F] text-white hover:bg-[#1a1918]"
					>
						<Link to={`/blog/${post.slug}`}>
							Read Article <ArrowUpRight size={16} />
						</Link>
					</AnimatedButton>
				</div>
			</div>
		</div>
	)
}
